export var BOTPRESS_PROVIDER_ID = 'botpress-provider';
export var BOTPRESS_SCRIPT_NAME = 'botpress-script';
export var IFRAME_QUERY_SELECTOR = 'iframe[name="webchat"]';
export var MESSAGE_CONTAINER_SELECTOR = '.bpMessageListContainer';

// Link Enhancer
export var DATA_ENHANCED_ATTRIBUTE = 'data-enhanced';
export var DATA_ENHANCED_ATTRIBUTE_TRUE = 'true';
export var MUTATION_OBSERVER_TAG = 'a';
export var EXTERNAL_WINDOW_TARGET = '_blank';
export var EXTERNAL_WINDOW_REL = 'noopener noreferrer';

// Mutation Observer
export var OBSERVER_TIMEOUT = 500;
export var MAX_OBSERVER_RETRIES = 10;
export var MAX_IFRAME_RETRIES = 10;
export var INJECTED_SCRIPT_ELEMENT_SELECTORS = ['iframe[name="webchat"]',
// Main webchat iframe
'iframe[name="fab"]' // FAB iframe
];